<template>
  <p
    ref="number"
  >
    <slot />
  </p>
</template>

<script>
import inViewport from 'vue-in-viewport-mixin'
import createNumberAnimation from '@/assets/js/highlight/number'
export default {
  mixins: [inViewport],
  props: {
    listAnimationStart: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      textTimeline: new TimelineMax({ paused: true })
    }
  },
  watch: {
    listAnimationStart (start) {
      if (start) {
        this.textTimeline.play()
      } else {
        this.textTimeline.pause()
        this.textTimeline.seek(0)
      }
    }
  },
  mounted () {
    const number = this.$refs.number
    const numberInner = number.firstChild
    const textAnimation = createNumberAnimation(numberInner)

    TweenLite.set(numberInner, { top: '1em' })
    this.textTimeline.add(textAnimation)
  }

}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/TextHighlightAnimation/NumberHighlight.vue